module.exports = __webpack_public_path__ + "assets/red-hat.0706bac9.svg";